(function () {
  'use strict';

  angular
    .module('app.notify', []);
})();
